import { bigIntToLong } from '#common/util';
import { ServiceBaseProto, SessionMessageType, SessionRequestMsg, } from '#websocket/client/proto';
const SESSION_REQUEST_TYPE = '.SessionRequestMsg.sessionRequest';
const SESSION_RESPONSE_TYPE = '.SessionResponseMsg.sessionResponse';
export class SessionRequest {
    jwt;
    destination;
    constructor(jwt, destination) {
        this.jwt = jwt;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        const sessionRequest = SessionRequestMsg.create({
            type: SessionMessageType.LOGIN,
            login: { filespaceToken: this.jwt },
        });
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [SESSION_REQUEST_TYPE]: sessionRequest,
        });
    }
    createResponse(responseMessage) {
        return new SessionResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
}
export class SessionResponse {
    result;
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        this.result = responseMsgObject[SESSION_RESPONSE_TYPE].sessionToken;
    }
}
